import { render, staticRenderFns } from "./tunnelPolicyCom.vue?vue&type=template&id=a592d606&"
import script from "./tunnelPolicyCom.vue?vue&type=script&lang=ts&"
export * from "./tunnelPolicyCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports